import { useParams, Link, Navigate } from "react-router-dom";
import { CheckCircle2, ChevronRight } from "lucide-react";
import { PageHero, SectionHeading, CTABand } from "../components/shared";
import { Reveal } from "../components/Reveal";
import { SERVICES } from "../data/content";

const ServiceDetail = () => {
  const { slug } = useParams();
  const s = SERVICES.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/services" replace />;
  const others = SERVICES.filter((x) => x.slug !== slug).slice(0, 4);

  return (
    <>
      <PageHero overline="Service" title={s.title} subtitle={s.headline} image={s.image} />
      <section className="py-24 bg-white">
        <div className="max-w-[1360px] mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-8">
            <SectionHeading overline={s.headline} title="Scope of Support" sub={s.short} />
            <div className="mt-10 grid sm:grid-cols-2 gap-3">
              {s.items.map((it, i) => (
                <Reveal key={it} delay={(i % 6) * 0.03}>
                  <div className="flex items-start gap-3 bg-[#F4F6F8] border border-[#E2E8F0] rounded-md p-4">
                    <CheckCircle2 className="h-5 w-5 text-[#1261A0] shrink-0 mt-0.5" />
                    <span className="text-[15px] text-[#252B33]">{it}</span>
                  </div>
                </Reveal>
              ))}
            </div>
            {s.extra && (
              <div className="mt-10">
                <h3 className="font-head font-semibold text-xl text-[#0B1F3A]">{s.extra.title}</h3>
                <div className="mt-4 flex flex-wrap gap-3">
                  {s.extra.list.map((e) => <span key={e} className="bg-[#0B1F3A] text-white text-sm px-4 py-2 rounded-full">{e}</span>)}
                </div>
              </div>
            )}
            <p className="mt-8 text-sm text-[#64748B] italic">Specific capabilities are engaged only where they accurately reflect Airanet&apos;s approved scope. Statements remain editable for client approval.</p>
          </div>
          <aside className="lg:col-span-4">
            <div className="sticky top-24 bg-[#0B1F3A] text-white rounded-lg p-7">
              <h3 className="font-head font-semibold text-lg">Discuss this capability</h3>
              <p className="mt-3 text-sm text-[#CBD5E1]">Tell us about your requirement and we will propose an engagement model.</p>
              <Link to="/contact" className="mt-6 inline-flex items-center gap-2 bg-[#F28C28] text-[#0B1F3A] font-semibold px-5 py-3 rounded-md w-full justify-center">Request a Discussion <ChevronRight className="h-4 w-4" /></Link>
              <div className="mt-8 space-y-2">
                <p className="text-xs uppercase tracking-[0.2em] text-[#1EA7E1] font-semibold">Related Services</p>
                {others.map((o) => (
                  <Link key={o.slug} to={`/services/${o.slug}`} className="block text-sm text-[#CBD5E1] hover:text-white py-1.5 border-b border-white/10">{o.title}</Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>
      <CTABand />
    </>
  );
};

export default ServiceDetail;
